import { useTheme } from "@emotion/react";
import { useTranslation, Trans } from "react-i18next";

import { Typography, Arrange } from "@aviary/components";
import { l } from "@aviary/locales/i18n";
import {
  SvgHipaaLogoPrimary,
  SvgSecureCheckoutPrimary,
  SvgHipaaLogoWhite,
  SvgSecureCheckoutWhite,
} from "@shared/assets/logo";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

import type { PageFooterProps } from "../PageFooter.types";

import * as styles from "./FooterIcons.styles";

const FooterIcons = ({ type, hideHipaaLogo }: PageFooterProps) => {
  const { t } = useTranslation();
  const { isUS } = useSharedGlobalConfig();
  const { desktop } = useBreakpoints();
  const currentTheme = useTheme();

  const isDS4DarkMode = currentTheme.theme === "dark";

  const renderHipaaLogo = (ariaLabel: string) => {
    if (!isUS) return null;
    if (isDS4DarkMode) return <SvgHipaaLogoWhite role="img" aria-label={ariaLabel} />;

    return <SvgHipaaLogoPrimary role="img" aria-label={ariaLabel} />;
  };

  const renderProductIcons = () => {
    if (type === "product" && !hideHipaaLogo) {
      return <div>{renderHipaaLogo(t(l.aviary.footer.HIPAAalttext))}</div>;
    }
  };

  const renderSecureCheckoutIcon = (ariaLabel: string) => {
    if (isDS4DarkMode) return <SvgSecureCheckoutWhite role="img" aria-label={ariaLabel} />;

    return <SvgSecureCheckoutPrimary role="img" aria-label={ariaLabel} />;
  };

  const renderCheckoutIcons = () => {
    if (type === "checkout") {
      return (
        <Arrange isWrapped={false} alignment="center">
          {renderSecureCheckoutIcon(t(l.aviary.footer.SecureCheckoutIcon))}
          <Typography type="footnote" css={styles.secureText}>
            <Trans i18nKey={l.aviary.footer.SecureCheckout}>
              Fullscript ensures all payment information is <strong>stored securely</strong>.
            </Trans>
          </Typography>
        </Arrange>
      );
    }
  };

  return (
    <Arrange alignment="center" justify={desktop.lessThan ? "center" : undefined}>
      {renderProductIcons()}
      {renderCheckoutIcons()}
    </Arrange>
  );
};

export { FooterIcons };
